export default {
  INDEX: "/",
  CREATE: "/create",
  ERROR: '/error',
  UPLOAD: "/upload",
  QRCODE_CAMERA: "/qrcode/camera",
  PROCESSING: "/processing/:hash?",
  RESULT: "/result",
};
